import { withSchema } from '@websolutespa/bom-core';
import { Accordion as AccordionBase } from './accordion';
import { AccordionContent } from './accordion-content';
import { AccordionGroup } from './accordion-group';
import { AccordionSubtitle } from './accordion-subtitle';
import { AccordionTitle } from './accordion-title';

export const Accordion = withSchema(
  AccordionBase,
  {
    Content: AccordionContent,
    Group: AccordionGroup,
    Title: AccordionTitle,
    Subtitle: AccordionSubtitle,
  });

export type { AccordionProps } from './accordion';
export type { AccordionContentProps } from './accordion-content';
export type { AccordionGroupProps } from './accordion-group';
export type { AccordionSubtitleProps } from './accordion-subtitle';
export type { AccordionTitleProps } from './accordion-title';

export * from './accordion.variants';

